(() => {
  'use strict';
  if (window.NakedProductCards) return;
  window.NakedProductCards = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const bound = new WeakSet();
  const enhance = root => {
    root.querySelectorAll('.t4s-pr-style2 .t4s-product-inner [data-action-quickshop]').forEach(button => {
      const label = button.querySelector('.t4s-text-pr');
      if (label && root.dataset.nkdAtcLabel && label.textContent !== root.dataset.nkdAtcLabel) label.textContent = root.dataset.nkdAtcLabel;
    });
    root.querySelectorAll('.t4s-pr-style2 .t4s-pr-color__item[data-vid]').forEach(swatch => {
      if (swatch.getAttribute('role') !== 'button') {
        swatch.setAttribute('role', 'button');
        swatch.tabIndex = 0;
        swatch.setAttribute('aria-label', swatch.querySelector('.t4s-pr-color__name')?.textContent.trim() || 'Color');
      }
      const selected = String(swatch.classList.contains('is-swatch--selected'));
      if (swatch.getAttribute('aria-pressed') !== selected) swatch.setAttribute('aria-pressed', selected);
    });
  };
  const init = () => document.querySelectorAll('[data-naked-product-cards]').forEach(root => {
    if (bound.has(root)) return;
    bound.add(root);
    enhance(root);
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; enhance(root); });
    });
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    root.addEventListener('keydown', event => {
      const swatch = event.target.closest('.t4s-pr-color__item[data-vid]');
      if (!swatch || !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      swatch.click();
    });
    const animateColor = event => {
      const swatch = event.target.closest('.t4s-pr-color__item[data-vid]');
      if (!swatch || swatch.classList.contains('is-swatch--selected') || reduced.matches) return;
      if (event.type === 'pointerover' && (event.pointerType === 'touch' || swatch.contains(event.relatedTarget))) return;
      const card = swatch.closest('.t4s-pr-style2');
      const image = card?.querySelector('.t4s-product-img');
      if (!image) return;
      image.getAnimations().forEach(animation => animation.cancel());
      image.animate([{ opacity: .65 }, { opacity: 1 }], { duration: 380, easing: 'ease-out' });
    };
    root.addEventListener('pointerover', animateColor);
    root.addEventListener('click', animateColor, true);
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();

